import axios from "axios";

export default {
  state: {
    listCorGov: [],
  },
  getters: {
    getListCorGov(state) {
      return state.listCorGov;
    },
  },
  mutations: {
    setListCorGov(state, payload) {
      state.listCorGov = payload;
    },
  },
  actions: {
    fetchListCorGov(store, payload) {
      const storage = JSON.parse(localStorage.getItem("token"));
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_BACKEND + "api/corporateGovernance",
          params: { parent : payload.parent ? payload.parent : "" },
          headers: {
            "Content-Type": "application/json",
            token: storage.token
          },
        })
          .then(res => {
            store.commit("setListCorGov", res.data);
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // createDelegation(store, payload) {
    //   const storage = JSON.parse(localStorage.getItem("token"));
    //   return new Promise((resolve, reject) => {
    //     axios({
    //       method: "post",
    //       url: process.env.VUE_APP_BACKEND + "api/delegation",
    //       data: payload,
    //       headers: {
    //         "Content-Type": "application/json",
    //         token: storage.token
    //       },
    //     })
    //       .then(res => {
    //         resolve(res);
    //       })
    //       .catch((error) => {
    //         reject(error);
    //       });
    //   });
    // },
    // updateDelegation({ dispatch }, payload) {
    //   const storage = JSON.parse(localStorage.getItem("token"));
    //   return new Promise((resolve, reject) => {
    //     axios({
    //       method: "put",
    //       url: process.env.VUE_APP_BACKEND + "api/delegation",
    //       params: { id: payload },
    //       headers: {
    //         "Content-Type": "application/json",
    //         token: storage.token
    //       },
    //     })
    //       .then(res => {
    //         dispatch("fetchList");
    //         resolve(res);
    //       })
    //       .catch((error) => {
    //         reject(error);
    //       });
    //   });
    // },
    // checkDelegation(store, payload) {
    //   const storage = JSON.parse(localStorage.getItem("token"));
    //   return new Promise((resolve, reject) => {
    //     axios({
    //       method: "get",
    //       url: process.env.VUE_APP_BACKEND + "api/checkDelegation",
    //       params: {
    //         tlc: payload.tlc,
    //         aplikasi: payload.aplikasi
    //       },
    //       headers: {
    //         "Content-Type": "application/json",
    //         token: storage.token
    //       },
    //     })
    //       .then(res => {
    //         resolve(res.data);
    //       })
    //       .catch((error) => {
    //         reject(error);
    //       });
    //   });
    // },
  },
};
